import { render, staticRenderFns } from "./MainContractPoints.vue?vue&type=template&id=d9fae8e2&scoped=true&"
import script from "./MainContractPoints.vue?vue&type=script&lang=js&"
export * from "./MainContractPoints.vue?vue&type=script&lang=js&"
import style0 from "./MainContractPoints.vue?vue&type=style&index=0&id=d9fae8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fae8e2",
  null
  
)

export default component.exports